import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer id="contato">
      <div className="footer-top">
        <div className="footer-brand">
          <Link to="/" className="logo">Havel <em>br</em></Link>
          <p className="footer-tagline">{t.footer.tagline}</p>
        </div>
        <div className="footer-col">
          <h4>{t.footer.navTitle}</h4>
          <ul>
            <li><a href="#apps">{t.nav.apps}</a></li>
            <li><a href="#sobre">{t.nav.about}</a></li>
            <li><a href="#">{t.footer.gplay}</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>{t.footer.legalTitle}</h4>
          <ul>
            <li><Link to="/legal">{t.footer.legalHub}</Link></li>
            <li><Link to="/legal/termo/privacidade">{t.footer.privacyOf('Termo!')}</Link></li>
            <li><Link to="/legal/lume/privacidade">{t.footer.privacyOf('Lume')}</Link></li>
            <li><Link to="/legal/julius/privacidade">{t.footer.privacyOf('Julius')}</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>{t.footer.contactTitle}</h4>
          <ul>
            <li><a href="mailto:eric.havel@gmail.com">eric.havel@gmail.com</a></li>
            <li><a href="#">{t.footer.location}</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span className="footer-copy">{t.footer.rights}</span>
        <div className="socials">
          <a href="https://www.instagram.com/havel.br?igsh=MW5weWVocmg2OHp0eQ==" className="social" title="Instagram" target="_blank" rel="noopener">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
            </svg>
          </a>
          <a href="https://x.com/havel_br" className="social" title="X (Twitter)" target="_blank" rel="noopener">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
